import React, { useState, useEffect } from 'react';
import { Card, Table, Input, Space, Tag, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { orderApi } from '@/services/api';
import dayjs from 'dayjs';

const OrderList = () => {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadOrders();
  }, [pagination.current, pagination.pageSize]);

  const loadOrders = async () => {
    setLoading(true);
    try {
      const response = await orderApi.list({
        page: pagination.current,
        limit: pagination.pageSize,
        search
      });

      if (response.data.success) {
        setOrders(response.data.data);
        setPagination({
          ...pagination,
          total: response.data.pagination.total
        });
      }
    } catch (error) {
      message.error('載入訂單列表失敗');
    } finally {
      setLoading(false);
    }
  };

  const getStatusTag = (status) => {
    const statusConfig = {
      pending: { color: 'default', text: '待確認' },
      confirmed: { color: 'blue', text: '已確認' },
      processing: { color: 'processing', text: '處理中' },
      shipped: { color: 'cyan', text: '已出貨' },
      delivered: { color: 'success', text: '已送達' },
      cancelled: { color: 'error', text: '已取消' }
    };
    const config = statusConfig[status] || statusConfig.pending;
    return <Tag color={config.color}>{config.text}</Tag>;
  };

  const columns = [
    {
      title: '訂單號',
      dataIndex: 'order_no',
      key: 'order_no'
    },
    {
      title: '客戶',
      dataIndex: 'contact_name',
      key: 'contact_name'
    },
    {
      title: '金額',
      dataIndex: 'grand_total',
      key: 'grand_total',
      render: (amount) => `NT$ ${parseFloat(amount).toLocaleString()}`
    },
    {
      title: '付款狀態',
      dataIndex: 'payment_status',
      key: 'payment_status',
      render: (status) => {
        const statusMap = {
          unpaid: { color: 'default', text: '未付款' },
          partial: { color: 'warning', text: '部分付款' },
          paid: { color: 'success', text: '已付款' }
        };
        const config = statusMap[status] || statusMap.unpaid;
        return <Tag color={config.color}>{config.text}</Tag>;
      }
    },
    {
      title: '訂單狀態',
      dataIndex: 'status',
      key: 'status',
      render: getStatusTag
    },
    {
      title: '建立時間',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => dayjs(date).format('YYYY-MM-DD')
    }
  ];

  return (
    <div>
      <Card>
        <Space style={{ marginBottom: 16 }} wrap>
          <Input
            placeholder="搜尋訂單號、客戶"
            prefix={<SearchOutlined />}
            style={{ width: 250 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={loadOrders}
          />
        </Space>

        <Table
          columns={columns}
          dataSource={orders}
          loading={loading}
          rowKey="id"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 筆`,
            onChange: (page, pageSize) => {
              setPagination({ ...pagination, current: page, pageSize });
            }
          }}
        />
      </Card>
    </div>
  );
};

export default OrderList;
